export default {
  removeAccents(text) {
    text = text.replace(/[àáâãÀÁÂÃ]/ig, 'a');
    text = text.replace(/[èéêÈÉÊ]/ig, 'e');
    text = text.replace(/[ìíÌÍ]/ig, 'i');
    text = text.replace(/[òóôÒÓÔ]/ig, 'o');
    text = text.replace(/[ùúüÙÚÜ]/ig, 'u');
    text = text.replace(/[çÇ]/ig, 'c');

    return text;
  },

  filterValues(values) {
    return values.filter(x => {
      const options = this.options.map(o => o[this.valueField] ? o[this.valueField].toString() : o.toString());
      return x && options.indexOf(x.toString()) > -1;
    });
  }
};
